module.exports = __webpack_public_path__ + "img/0xDC7aaEdDB142Ec4a13de6FA27B92D166AE606536.cf97f620.png";